import { LANGUAGES as e } from '../../../utils/languageResolver.js';

var t=[[[e.RU,e.KO,e.ZH_CN,e.ZH_TW,e.TH,e.JA,e.PL,e.EN,e.PT,e.IT,e.PT_BR],function(){return "{input}%"}],[[e.UK,e.DE,e.FR,e.ES,e.CS,e.ES_MX],function(){return "{input} %"}],[[e.TR],function(){return "%{input}"}]];

export { t as default };
//# sourceMappingURL=index.js.map
